import styled from 'styled-components';
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Icons, BaseStyles } from '@pik/pik-ui';

var defaultLinks = [{
  title: 'Проекты',
  linksItems: [{
    url: '/',
    text: 'Москва',
    target: '_self'
  }, {
    url: '/spb',
    text: 'Санкт-Петербург',
    target: '_self'
  }, {
    url: '/ekb',
    text: 'Екатеринбург',
    target: '_self'
  }, {
    url: '/tumen',
    text: 'Тюмень',
    target: '_self'
  }, {
    url: '/rostov-na-donu',
    text: 'Ростов-на-Дону',
    target: '_self'
  }, {
    url: '/novorossiisk',
    text: 'Новороссийск',
    target: '_self'
  }, {
    url: '/yaroslavl',
    text: 'Ярославль',
    target: '_self'
  }, {
    url: '/perm/projects/cars/',
    text: 'Пермь',
    target: '_self'
  }, {
    url: '/kaluga',
    text: 'Калуга',
    target: '_self'
  }, {
    url: '/obninsk',
    text: 'Обнинск',
    target: '_self'
  }]
}, {
  title: 'Компания',
  linksItems: [{
    url: 'http://pik-group.ru/about/history',
    text: 'О компании',
    target: '_blank'
  }, {
    url: 'http://pik-group.ru/corporate-governance',
    text: 'Корп. управление',
    target: '_blank'
  }, {
    url: 'http://pik-group.ru/investors',
    text: 'Инвесторам',
    target: '_blank'
  }, {
    url: '/news?type=press',
    text: 'Пресса',
    target: ''
  }, {
    url: '/job',
    text: 'Карьера',
    target: ''
  }, {
    url: 'https://tender.pik.ru/',
    text: 'Тендеры',
    target: '_blank'
  }, {
    url: 'http://pik-group.ru/contacts-directory/head-office',
    text: 'Контакты',
    target: '_blank'
  }, {
    url: 'https://www.pik.ru/offices',
    text: 'Офисы продаж',
    target: '_blank'
  }]
}, {
  title: 'Услуги',
  linksItems: [{
    url: 'https://www.pik.ru/mortgage/about',
    text: 'ПИК-Ипотека'
  }, {
    url: 'https://pik-arenda.ru/?utm_source=pik.ru&utm_medium=site_link&utm_campaign=footer',
    text: 'ПИК-Аренда',
    isMoscow: true
  }, {
    url: 'https://pik-broker.ru/?utm_source=pik.ru&utm_medium=referral&utm_campaign=footer',
    text: 'ПИК-Брокер',
    target: '_blank',
    isMoscow: true

  },
  // {
  //   url     : 'https://localkitchen.ru/',
  //   text    : 'Кухня на районе',
  //   target  : '_blank',
  //   isMoscow: true
  // },
  {
    url: 'http://pik-remont.ru/?utm_source=pik.ru&amp;utm_medium=referral&amp;utm_campaign=footer',
    text: 'ПИК-Ремонт',
    target: '_blank',
    isMoscow: true
  }, {
    url: '#chekin',
    text: 'Запись в офис',
    target: '',
    isMoscow: true
  }, {
    url: '/franchise',
    text: 'Франшиза'
  }]
}];

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var taggedTemplateLiteral = function (strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var _templateObject = taggedTemplateLiteral(['\n  box-sizing: border-box;\n  border: 1px solid #D9D9D9;\n  border-radius: 4px;\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  justify-content: flex-start;\n  transition: border-color ease .4s;\n  outline: none;\n'], ['\n  box-sizing: border-box;\n  border: 1px solid #D9D9D9;\n  border-radius: 4px;\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  justify-content: flex-start;\n  transition: border-color ease .4s;\n  outline: none;\n']),
    _templateObject2 = taggedTemplateLiteral(['\n  width: 24px;\n  height: 24px;\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  justify-content: center;\n  \n  svg {\n    width: 16px;\n    height: 16px;\n    fill: #484848;\n  }\n'], ['\n  width: 24px;\n  height: 24px;\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  justify-content: center;\n  \n  svg {\n    width: 16px;\n    height: 16px;\n    fill: #484848;\n  }\n']),
    _templateObject3 = taggedTemplateLiteral(['\n  display: inline-block;\n  font-size: 13px;\n  color: #484848;\n  letter-spacing: 0;\n\n  &:hover {\n    cursor: pointer;\n    border: 1px solid #BFBFBF;\n  }\n'], ['\n  display: inline-block;\n  font-size: 13px;\n  color: #484848;\n  letter-spacing: 0;\n\n  &:hover {\n    cursor: pointer;\n    border: 1px solid #BFBFBF;\n  }\n']);

var StyledButton = styled.button(_templateObject);

var ButtonIcon = styled.span(_templateObject2);

var ButtonText = styled.span(_templateObject3);

var Button = function (_Component) {
  inherits(Button, _Component);

  function Button() {
    classCallCheck(this, Button);
    return possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).apply(this, arguments));
  }

  createClass(Button, [{
    key: 'getIcon',
    value: function getIcon(type) {
      switch (type) {
        case 'callback':
          return React.createElement(
            'svg',
            { width: '16', height: '16', viewBox: '0 0 16 16' },
            React.createElement('path', {
              d: 'M3.72 1c-.178 0-.414.046-.665.226C3.035 1.241 1 2.73 1 3.546l.002.048c.095 1.925 1.55 4.307 4.323 7.08 2.773 2.774 5.155 4.228 7.08 4.324h.032l.026.002c.833 0 2.296-2.035 2.31-2.055.377-.528.24-1.118-.101-1.362-.223-.168-2.574-1.707-2.861-1.879-.309-.176-.731-.143-1.108.083-.223.122-.92.521-1.244.707-.288-.198-.994-.733-2.094-1.854-1.104-1.102-1.65-1.81-1.857-2.102.188-.325.585-1.021.71-1.252.226-.412.252-.837.07-1.11-.161-.269-1.73-2.65-1.871-2.847a.822.822 0 0 0-.59-.323A.913.913 0 0 0 3.72 1z',
              fillRule: 'nonzero',
              stroke: '#484848',
              fill: 'none'
            })
          );
        case 'heart':
          return React.createElement(
            'svg',
            { width: '14', viewBox: '0 0 14 13' },
            React.createElement('path', {
              d: 'M4 0C1.8 0 0 1.8 0 4c0 1.9 1 3.1 2.3 4.2 1.3 1.1 2.8 2.2 4.3 4.2l.4.6.4-.6c1.5-2 3-3.1 4.3-4.2C13 7.1 14 5.9 14 4c0-2.2-1.8-4-4-4-1.3 0-2.3.7-3 1.5C6.3.7 5.3 0 4 0zm0 1c1.1 0 2.1.7 2.6 1.4L7 3l.4-.6C7.9 1.7 8.9 1 10 1c1.7 0 3 1.3 3 3 0 1.6-.7 2.4-2 3.4-1.1 1-2.6 2.1-4 4-1.4-1.8-2.9-3-4-4-1.3-1-2-1.8-2-3.4 0-1.7 1.3-3 3-3z'
            })
          );
        case 'dialog':
          return React.createElement(
            'svg',
            { width: '14', viewBox: '0 0 14 13' },
            React.createElement('path', {
              d: 'M1.5 0C.7 0 0 .7 0 1.5v5C0 7.3.7 8 1.5 8H3v2l2.7-2h2.8c.8 0 1.5-.7 1.5-1.5v-5C10 .7 9.3 0 8.5 0h-7zm0 1h7c.3 0 .5.2.5.5v5c0 .3-.2.5-.5.5H5.3L4 8V7H1.5c-.3 0-.5-.2-.5-.5v-5c0-.3.2-.5.5-.5zM11 3v1h1.5c.3 0 .5.2.5.5v5c0 .3-.2.5-.5.5H10v1l-1.3-1H5.5c-.2 0-.4-.1-.5-.3l-.8.6c.3.4.8.7 1.3.7h2.8l2.7 2v-2h1.5c.8 0 1.5-.7 1.5-1.5v-5c0-.8-.7-1.5-1.5-1.5H11z'
            })
          );
        default:
          return null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          text = _props.text,
          icon = _props.icon;

      var padding = '7px 16px';

      if (!text) {
        return null;
      }

      if (icon) {
        padding = '7px 16px 7px 11px';
      }

      return React.createElement(
        StyledButton,
        {
          style: { padding: padding }
        },
        icon && React.createElement(
          ButtonIcon,
          null,
          this.getIcon(icon)
        ),
        React.createElement(
          ButtonText,
          null,
          text
        )
      );
    }
  }]);
  return Button;
}(Component);

Button.propTypes = {
  text: PropTypes.string.isRequired,
  icon: PropTypes.string
};
Button.defaultProps = {
  icon: null
};

var _templateObject$1 = taggedTemplateLiteral(['\n  display: inline-block;\n  width: 64px;\n  height: 64px;\n  box-sizing: border-box;\n  \n  .Icons {\n    width: 100%;\n    height: 100%;\n    box-sizing: border-box;\n    \n    svg {\n      width: 100%;\n      height: 100%;\n      box-sizing: border-box;\n    }\n  }\n'], ['\n  display: inline-block;\n  width: 64px;\n  height: 64px;\n  box-sizing: border-box;\n  \n  .Icons {\n    width: 100%;\n    height: 100%;\n    box-sizing: border-box;\n    \n    svg {\n      width: 100%;\n      height: 100%;\n      box-sizing: border-box;\n    }\n  }\n']);

var S = {};

S.Logo = styled.div(_templateObject$1);

var Logo = (function () {
  return React.createElement(
    S.Logo,
    null,
    React.createElement(Icons, { type: 'logo' })
  );
});

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var isMobile = (function () {
  return canUseDOM && window.innerWidth < 625;
});

var disableScrollCssClass = {
  on: function on() {
    if (canUseDOM) {
      var html = document.getElementsByTagName('html')[0];
      var app = document.getElementById('app');
      if (app) {
        var scrollVisible = window.innerWidth - document.documentElement.clientWidth;

        html.classList.add('noscroll');

        if (scrollVisible) {
          html.classList.add('scroll-visible');
          app.style.paddingRight = scrollVisible + 'px';
        }

        if (isMobile()) {
          app.style.overflowY = 'hidden';
        }
      }
    }
  },
  off: function off() {
    if (canUseDOM) {
      var html = document.getElementsByTagName('html')[0];
      var app = document.getElementById('app');
      if (app) {
        html.classList.remove('noscroll');
        html.classList.remove('scroll-visible');
        app.style.paddingRight = '0';

        if (isMobile()) {
          app.style.overflowY = 'auto';
          app.style.overflowX = 'hidden';
        }
      }
    }
  }
};

var max768 = 'only screen and (max-width: 767px)';
var max960 = 'only screen and (max-width: 959px)';

var _templateObject$2 = taggedTemplateLiteral(['\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  background-color: #fff;\n  z-index: 10;\n  overflow: scroll;\n'], ['\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  background-color: #fff;\n  z-index: 10;\n  overflow: scroll;\n']),
    _templateObject2$1 = taggedTemplateLiteral(['\n  position: relative;\n  margin-left: 250px;\n  top: 190px;\n  \n  @media ', ' {\n    top: 100px;\n    margin-left: 0;\n    padding-left: 20px;\n    box-sizing: border-box;\n  } \n  \n  @media ', ' {\n    padding-bottom: 10px;\n  } \n'], ['\n  position: relative;\n  margin-left: 250px;\n  top: 190px;\n  \n  @media ', ' {\n    top: 100px;\n    margin-left: 0;\n    padding-left: 20px;\n    box-sizing: border-box;\n  } \n  \n  @media ', ' {\n    padding-bottom: 10px;\n  } \n']),
    _templateObject3$1 = taggedTemplateLiteral(['\n  font-family: Graphik;\n  font-weight: 500;\n  font-size: 60px;\n  color: #484848;\n  line-height: 70px;\n  \n  @media ', ' {\n    font-size: 38px;\n  } \n'], ['\n  font-family: Graphik;\n  font-weight: 500;\n  font-size: 60px;\n  color: #484848;\n  line-height: 70px;\n  \n  @media ', ' {\n    font-size: 38px;\n  } \n']),
    _templateObject4 = taggedTemplateLiteral(['\n  font-family: Graphik;\n  font-size: 24px;\n  color: #484848;\n  line-height: 70px;\n  \n  @media ', ' {\n    font-size: 15px;\n    line-height: 21px;\n    margin-bottom: 30px;\n  } \n'], ['\n  font-family: Graphik;\n  font-size: 24px;\n  color: #484848;\n  line-height: 70px;\n  \n  @media ', ' {\n    font-size: 15px;\n    line-height: 21px;\n    margin-bottom: 30px;\n  } \n']),
    _templateObject5 = taggedTemplateLiteral(['\n  display: block;\n  position: relative;\n  width: 64px;\n  height: 64px;\n  top: 64px;\n  left: 64px;\n  \n  @media ', ' {\n    top: 28px;\n    left: 20px;\n  } \n'], ['\n  display: block;\n  position: relative;\n  width: 64px;\n  height: 64px;\n  top: 64px;\n  left: 64px;\n  \n  @media ', ' {\n    top: 28px;\n    left: 20px;\n  } \n']),
    _templateObject6 = taggedTemplateLiteral(['\n  font-family: Graphik;\n  font-size: 16px;\n  color: #6E8490;\n  line-height: 40px;\n  text-decoration: underline !important;\n  padding-bottom: 5px;\n  \n  @media ', ' {\n    font-size: 15px;\n    position: relative;\n    left: 19px;\n    padding-bottom: 2px;\n  } \n\n  > span {\n    position: absolute;\n    left: -19px;\n  }\n'], ['\n  font-family: Graphik;\n  font-size: 16px;\n  color: #6E8490;\n  line-height: 40px;\n  text-decoration: underline !important;\n  padding-bottom: 5px;\n  \n  @media ', ' {\n    font-size: 15px;\n    position: relative;\n    left: 19px;\n    padding-bottom: 2px;\n  } \n\n  > span {\n    position: absolute;\n    left: -19px;\n  }\n']),
    _templateObject7 = taggedTemplateLiteral(['\n  margin-top: 77px;\n  display: flex;\n  \n  @media ', ' {\n    flex-wrap: wrap;\n    margin-top: 30px;\n    flex-direction: column;\n    max-height: 700px;\n  }\n'], ['\n  margin-top: 77px;\n  display: flex;\n  \n  @media ', ' {\n    flex-wrap: wrap;\n    margin-top: 30px;\n    flex-direction: column;\n    max-height: 700px;\n  }\n']),
    _templateObject8 = taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  margin-right: 123px;\n  max-width: 230px;\n  \n  &:last-child {\n    margin-right: 0;\n  }\n  \n  @media ', ' {\n    margin-right: 0;\n    flex: 0 0 25%;\n    box-sizing: border-box;\n    padding: 0 20px 20px 0;\n  } \n  \n  @media ', ' {\n    width: 50%;\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  margin-right: 123px;\n  max-width: 230px;\n  \n  &:last-child {\n    margin-right: 0;\n  }\n  \n  @media ', ' {\n    margin-right: 0;\n    flex: 0 0 25%;\n    box-sizing: border-box;\n    padding: 0 20px 20px 0;\n  } \n  \n  @media ', ' {\n    width: 50%;\n  }\n']),
    _templateObject9 = taggedTemplateLiteral(['\n  width: fit-content;\n  text-decoration: underline !important;\n  display: block;\n  transition: color .4s ease;\n  font-family: Graphik;\n  color: #6E8490;\n  letter-spacing: 0;\n  line-height: 40px;\n  font-size: 16px;\n  \n  @media ', ' {\n    font-size: 15px;\n  } \n'], ['\n  width: fit-content;\n  text-decoration: underline !important;\n  display: block;\n  transition: color .4s ease;\n  font-family: Graphik;\n  color: #6E8490;\n  letter-spacing: 0;\n  line-height: 40px;\n  font-size: 16px;\n  \n  @media ', ' {\n    font-size: 15px;\n  } \n']),
    _templateObject10 = taggedTemplateLiteral(['\n  margin-top: 180px;\n  margin-bottom: 10px;\n  display: flex;\n  flex-direction: row;\n  \n  @media ', ' {\n    flex-direction: row;\n    align-items: baseline;\n    position: relative;\n  } \n  \n  @media ', ' {\n    align-items: end;\n    margin: 45px 0;\n    flex-direction: column;\n  } \n'], ['\n  margin-top: 180px;\n  margin-bottom: 10px;\n  display: flex;\n  flex-direction: row;\n  \n  @media ', ' {\n    flex-direction: row;\n    align-items: baseline;\n    position: relative;\n  } \n  \n  @media ', ' {\n    align-items: end;\n    margin: 45px 0;\n    flex-direction: column;\n  } \n']),
    _templateObject11 = taggedTemplateLiteral(['\n  margin-right: 25px;\n  \n  .pik_call_phone_footer_1 {\n    a{\n      font-family: Graphik;\n      font-size: 16px;\n      color: #6E8490;\n      line-height: 40px;\n    }\n  }\n  \n  @media ', ' {\n  .pik_call_phone_footer_1 {\n    a{\n      line-height: 26px;\n      font-weight: 500;\n      margin-bottom: 10px;\n      display: block;\n\n\n      span {\n          display: block;\n        }\n      }\n    }   \n  }\n'], ['\n  margin-right: 25px;\n  \n  .pik_call_phone_footer_1 {\n    a{\n      font-family: Graphik;\n      font-size: 16px;\n      color: #6E8490;\n      line-height: 40px;\n    }\n  }\n  \n  @media ', ' {\n  .pik_call_phone_footer_1 {\n    a{\n      line-height: 26px;\n      font-weight: 500;\n      margin-bottom: 10px;\n      display: block;\n\n\n      span {\n          display: block;\n        }\n      }\n    }   \n  }\n']);

var Container = styled.div(_templateObject$2);

var Wrapper = styled.div(_templateObject2$1, max960, max768);

var Title = styled.div(_templateObject3$1, max768);

var Text = styled.div(_templateObject4, max768);

var LogoContainer = styled.a(_templateObject5, max960);

var BackContainer = styled.a(_templateObject6, max960);

var ListContainer = styled.div(_templateObject7, max768);

var Item = styled.div(_templateObject8, max960, max768);

var ItemLink = styled.a(_templateObject9, max960);

var FooterCall = styled.div(_templateObject10, max960, max960);

var FooterText = styled.div(_templateObject11, max960);

var NotFoundPage = function (_Component) {
  inherits(NotFoundPage, _Component);

  function NotFoundPage() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, NotFoundPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = NotFoundPage.__proto__ || Object.getPrototypeOf(NotFoundPage)).call.apply(_ref, [this].concat(args))), _this), _this.showInverse = function () {
      var dispatch = _this.props.dispatch;
      // dispatch(actionCallBackHide());

      disableScrollCssClass.off();
    }, _this.clickCallBack = function () {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          popup = _this$props.popup;


      if (!popup) {
        // dispatch(actionShowPopup({ type }));
        disableScrollCssClass.on();
      }
    }, _this.renderFooter = function () {
      return React.createElement(
        FooterCall,
        null,
        React.createElement(
          FooterText,
          null,
          React.createElement('div', { dangerouslySetInnerHTML: {
              __html: '<span class="pik_call_phone_footer_1">' + '<a href="tel:88002669394"><span>Есть вопросы? Звоните</span>  8 (800) 266-93-94</a>' + '</span>'
            }
          })
        ),
        React.createElement(
          'span',
          { onClick: _this.clickCallBack },
          React.createElement(Button, { text: '\u041F\u0435\u0440\u0435\u0437\u0432\u043E\u043D\u0438\u0442\u0435 \u043C\u043D\u0435', icon: 'callback' })
        )
      );
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(NotFoundPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      window.addEventListener('orientationchange', function () {
        return _this2.forceUpdate();
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(_ref2) {
      var prevCallBackShow = _ref2.callBackShow;
      var callBackShow = this.props.callBackShow;

      if (!prevCallBackShow !== callBackShow) {
        if (callBackShow) {
          disableScrollCssClass.on();
        } else {
          disableScrollCssClass.off();
        }
      }
    }
  }, {
    key: 'renderLinks',
    value: function renderLinks() {
      var _this3 = this;

      return React.createElement(
        ListContainer,
        null,
        defaultLinks.map(function (item, i) {
          return _this3.renderLinksBlock(item, i);
        })
      );
    }
  }, {
    key: 'renderLinksBlock',
    value: function renderLinksBlock(_ref3, i) {
      var linksItems = _ref3.linksItems;

      return React.createElement(
        Item,
        { key: i },
        linksItems.map(function (_ref4, key) {
          var url = _ref4.url,
              text = _ref4.text,
              target = _ref4.target;
          return React.createElement(
            ItemLink,
            {
              key: key,
              target: target,
              href: url
            },
            text
          );
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var callBackShow = this.props.callBackShow;

      var modal = 'Footer-modal';

      if (callBackShow) {
        modal = modal + ' ' + modal + '--active';
      }

      return React.createElement(
        Container,
        null,
        React.createElement(
          LogoContainer,
          { href: '/' },
          React.createElement(Logo, null)
        ),
        React.createElement(
          Wrapper,
          null,
          React.createElement(
            Title,
            null,
            '\u041E\u0448\u0438\u0431\u043A\u0430 404.'
          ),
          React.createElement(
            Text,
            null,
            '\u0422\u0430\u043A\u043E\u0439 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043D\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442 \u0438\u043B\u0438 \u043E\u043D\u0430 \u0435\u0449\u0435 \u043D\u0435 \u0441\u043E\u0437\u0434\u0430\u043D\u0430.'
          ),
          React.createElement(
            BackContainer,
            { href: '/' },
            React.createElement(
              'span',
              null,
              '\u2190'
            ),
            '\u0412\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u043D\u0430 \u0433\u043B\u0430\u0432\u043D\u0443\u044E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443'
          ),
          this.renderLinks(),
          this.renderFooter()
        ),
        !isMobile() ? React.createElement('div', { className: modal, onClick: this.showInverse }) : null
      );
    }
  }]);
  return NotFoundPage;
}(Component);

var Core = function (_Component) {
  inherits(Core, _Component);

  function Core() {
    classCallCheck(this, Core);
    return possibleConstructorReturn(this, (Core.__proto__ || Object.getPrototypeOf(Core)).apply(this, arguments));
  }

  createClass(Core, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        Fragment,
        null,
        React.createElement(NotFoundPage, null),
        React.createElement(BaseStyles, null)
      );
    }
  }]);
  return Core;
}(Component);

export default Core;
//# sourceMappingURL=index.es.js.map
